import { useState } from 'react';

import API from '../../../../../libs/api';
import useAsyncEffect from '../../../foundation/hooks/use-async-effect';
import useFetch from '../../../foundation/hooks/use-fetch/use-fetch';

export default function useProviderEntityAttributes({
  serviceSettingId,
  locationId,
  forceInitialFetch = true,
} = {}) {
  const [providerEntityAttributes, setProviderEntityAttributes] = useState([]);

  const { fetching: loading, fetch, withFetch } = useFetch({ initialFetching: forceInitialFetch });

  async function getProviderEntityAttributes() {
    const data = await API.getBusinessProviderEntityAttributes({ serviceSettingId, locationId });
    return data;
  }

  async function fetchProviderEntityAttributes() {
    const data = await getProviderEntityAttributes();
    setProviderEntityAttributes(data);
  }

  async function updateProviderEntityAttribute(providerEntityId, payload) {
    await API.updateBusinessProviderEntityAttribute(providerEntityId, payload);
    await fetchProviderEntityAttributes();
  }

  useAsyncEffect(async () => {
    if (!forceInitialFetch) {
      return;
    }
    await fetch([fetchProviderEntityAttributes], { throwError: false });
  }, [serviceSettingId, locationId]);

  return {
    providerEntityAttributes,
    loading,
    refreshProviderEntityAttributes: withFetch(fetchProviderEntityAttributes, {
      throwError: false,
    }),
    getProviderEntityAttributes,
    updateProviderEntityAttribute,
  };
}
